export default __webpack_public_path__ + "static/media/butterfly.913985d5.jpeg";